module.exports = __webpack_public_path__ + "static/media/Scholarship.792d0e4d.svg";